<template>
	<v-card>
		<v-card-title
			class="d-flex align-center"
		>
			<v-icon
				icon="$message"
				start
			/>
			<translate>Claim Communication</translate>
		</v-card-title>
		<v-card-text>
			<v-expansion-panels
				v-model="expanded"
				variant="accordion"
				multiple
			>
				<v-expansion-panel
					v-for="(items, key) in claimQuestionsAnswers"
					:key="key"
					:title="key"
					elevation="0"
				>
					<v-expansion-panel-text>
						<v-table>
							<thead>
								<tr>
									<th class="text-left">
										<translate>Question</translate>
									</th>
									<th class="text-left">
										<translate>Answer</translate>
									</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="item in items"
									:key="item.question"
								>
									<td>{{ item.question }}</td>
									<td>{{ item.answer }}</td>
								</tr>
							</tbody>
						</v-table>
					</v-expansion-panel-text>
				</v-expansion-panel>
			</v-expansion-panels>
		</v-card-text>
	</v-card>
</template>

<script>
import {
	debounce,
} from 'lodash';
import axios from 'axios';

export default {
	name: 'ClaimCommunication',
	props: {
		claimId: {
			type: Number,
			required: true,
		},
	},

	data () {
		return {
			claimQuestionsAnswers: [],
			tableLoading: true,
			headers: [
				{
					title: this.$gettext('Question'), value: 'question',
				}, {
					title: this.$gettext('Answer'), value: 'answer',
				},
			],
			expanded: []
		};
	},

	mounted () {
		this.getData();
	},

	methods: {

		/**
		 * @param {Array} items
		 * @returns {Array}
		 */
		prependSections (items) {
			const sections = {
			};


			items.forEach(({
				answer, question, section
			}) => {
				if (!sections[section]) {
					sections[section] = [];
				}
				sections[section].push({
					answer: answer, question: question
				});
			});

			return sections;
		},

		/**
		 * Retrieve table data. Debounce to prevent calling this function too often
		 */
		getData: debounce(function () {
			axios.get(`/bo/claims/questionsandresponses?id=${this.claimId}`).then(({
				data,
			}) => {
				this.claimQuestionsAnswers = this.prependSections(data.items);
				this.expanded = [...Array(Object.keys(this.claimQuestionsAnswers).length).keys(),];
			}).catch((error) => {
				window.captureException(error);
			}).finally(() => {
				this.tableLoading = false;
			});
		}),
	},
};
</script>
